import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetSize } from '../../../providers/widgets.contants';
import { LoadingAndErrorComponent } from '../../loading-and-error/loading-and-error';
import { AbstractWidgetClass } from '../AbstractWidget.class';
import { WidgetCardComponent } from '../widget-card/widget-card';

@Component({
    styleUrls: ['./widget-monosite-only.scss'],
    selector: 'widget-monosite-only',
    templateUrl: 'widget-monosite-only.html',
    imports: [WidgetCardComponent, LoadingAndErrorComponent, TranslatePipe]
})
export class WidgetMonositeOnlyComponent extends AbstractWidgetClass<null, void> {
    size = WidgetSize.FULL;
}
